import React from 'react';
import './App.css';
import Cover from './components/Cover';
import picha from "./images/love.png"
import picha2 from "./images/religion.png"
import picha3 from "./images/occupation.png"
import picha4 from "./images/rl.png"
import { BrowserRouter , Link, Route , Switch } from 'react-router-dom';
import CreateMeme from './Pages/CreateMeme';
import About from './Pages/About';
import { FiHome } from "react-icons/fi";
import { FiPaperclip, FiThumbsUp } from "react-icons/fi";
function App() {
  return (
    <BrowserRouter> 

<div className="links">
<Link  to="/" className="link">{<FiHome value={{color:"red",className: "global-class-name"}}/>}</Link>   
<Link  to="/creatememe" className="link"> <FiPaperclip/> Create meme  </Link>  
<Link  to="/about" className="link"> <FiThumbsUp/></Link>
          
    </div> 
    
      
      
    <Route path="/" component={Home} exact/>
      <Route path="/creatememe" component={CreateMeme} />
       <Route path="/about" component={About}/>
    
       
       </BrowserRouter> 
   
  );
}

 const Home = () => {
   return (
     <>
       <div className="App">
      <h1>meBASE</h1>
<p>Kenyas Best Collection of memes</p>
<h3>Create memes,share and earn</h3>



      </div>


<div>
    
    <div className ="container">
    <Cover type="Relationships" imagee={picha} />
    <Cover type="Religion"  imagee={picha2}/>
    <Cover type="Occupation" imagee={picha3}/>
    </div>
    <div className ="container1">
    <Cover type="Politics" imagee={picha4}/>
    <Cover type="Tribe"/>
    <Cover type="Sports"/>
    </div>

    <div className ="container2">
    <Cover type="Lifestyle"/>
    <Cover type=""/>
    <Cover type=""/>
    </div>
   
    <div className ="container3">
    
    </div>
    
    </div>
    

     </>
   )
 }
 
 
 

export default App;
